import { Injectable } from '@angular/core';
import axios from 'axios';
import Promise from 'bluebird';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class HttpApiService {

    constructor(
        private router: Router,
    ) {
    }

    put(host, urlPart, parametros: any): any {
        return new Promise((resolve, reject) => {
            axios
                .put(host + urlPart, parametros)
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    // debugger
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }

    post(host, urlPart, parametros: any, options?): Promise<any> {
        const otps = { ...options, ... this.getHeader() }
        return new Promise((resolve, reject) => {
            axios
                .post(host + urlPart, parametros, otps)
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    // debugger
                    console.log('post - error - httpApiService')
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }

    postLogin(host, urlPart, parametros: any, options?): Promise<any> {
        const otps = { ...options, ... this.getHeader() }
        return new Promise((resolve, reject) => {
            axios
                .post(host + urlPart, parametros, otps)
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    // debugger
                    console.log('post - error - httpApiService')
                    this.closeSesion(e)
                    //reject(e);
                    reject(new Error(e.response.data.message));
                });
        });
    }

    postFile(host, parametros: any, config: any): any {
        return new Promise((resolve, reject) => {
            axios
                .post(host, parametros, config)
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    // debugger
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }

    get(host, urlPart, options?): any {
        return new Promise((resolve, reject) => {
            axios
                .get(host + urlPart, { ... this.getHeader(), ...options })
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    // debugger
                    console.log('get - error - httpApiService')
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }

    getParams(url, params): any {
        return new Promise((resolve, reject) => {
            axios
                .get(url, {
                    params: params, headers: {
                        'Authorization': localStorage.getItem("siged-token-cc")
                    }
                })
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }

    getTimeOut(host, urlPart, timeout): any {
        return new Promise((resolve, reject) => {
            axios
                .get(host + urlPart, this.getHeaderTimeOut(timeout))
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }


    postWithHeader(host, urlPart, parametros: any, headers: any): any {
        return new Promise((resolve, reject) => {
            axios
                .post(host + urlPart, parametros, headers)
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }

    postBlob(host, urlPart, parametros: any): any {
        return new Promise((resolve, reject) => {
            axios
                .post(host + urlPart, parametros, { responseType: 'blob' })
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }

    delete(host, urlPart): any {
        return new Promise((resolve, reject) => {
            axios
                .delete(host + urlPart)
                .then(data => {
                    resolve(data);
                })
                .catch(e => {
                    this.closeSesion(e)
                    reject(e);
                });
        });
    }

    getHeaderTimeOut(timeout) {
        return {
            headers: {
                'Authorization': localStorage.getItem("siged-token-cc"),
                'timeout': timeout
            }
        }
    }

    getHeader() {
        return {
            headers: { 'Authorization': localStorage.getItem("siged-token-cc") }
        }
    }

    closeSesion(e: any) {
        try{
            if(e.response != null && e.response.status == 403){
                localStorage.removeItem('siged-token-cc');
                localStorage.removeItem('siged-token-profile');
                localStorage.removeItem('perfiles');
                localStorage.removeItem('bandeja');
                this.router.navigate(['/'])
            }
        }catch (e){

        }

    }
}
